// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_eC6Hi","bgnone":"index_bgnone_vGhM2","ssr_nav":"index_ssr_nav_U0oev"};